import dayjs from "dayjs";
import About from "../../models/About";

const aboutData: About[] = [
  { title: "Building at Disney Streaming", subtitle: "Currently" },
  { title: "Paris → California", subtitle: "From / To" },
  { title: "Finding good restaurants", subtitle: "Side quests" },
  { title: "Building a smarter home", subtitle: "Current rabbit hole" },
  { title: "2019", subtitle: "Graduation" },
  { title: "Santa Monica, CA", subtitle: "Current location" },
  { title: dayjs().diff("1996-07-03", "year").toString(), subtitle: "Age" },
  {
    title: dayjs().diff("1996-07-03", "days").toString(),
    subtitle: "Days alive",
  },
];

export default aboutData;
